export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SUPER_WINDOW_DEVICE_NAME = 'SUPER_WINDOW_DEVICE_NAME'
export const SUPER_AGENT_URL = "SUPER_AGENT_URL";
export const SET_USER_DETAILS="SET_USER_DETAILS"
export const SET_GROUP_PLAN="SET_GROUP_PLAN"